import axios from "axios";
import jwtDecode from "jwt-decode";
//import { Exception } from "sass";
import AuthService from "../../components/jwt/auth.service";
import { setTotalItemMessageToast, checkTotalItemMessageToast } from '../../store/app/ws/WsSlice';

const axiosInstance = axios.create();
const myStorage = window.localStorage;

const legacyUser = JSON.parse(localStorage.getItem('user'));
const dsAccess = localStorage.getItem('access_token');
// Prefer the dedicated access_token key (Descope flow) over legacy 'user.access_token',
// since 'user' may contain a stale token depending on the login/refresh path taken.
const initialAccessToken = dsAccess || (legacyUser && legacyUser.access_token);

if (initialAccessToken) {
  axiosInstance.defaults.headers.common = { Authorization: `Bearer ${initialAccessToken}` };
}

axiosInstance.interceptors.request.use(
  request => {
    const uuID = crypto.randomUUID();
    const legacyUserRef = JSON.parse(localStorage.getItem('user'));
    const dsAccessRef = localStorage.getItem('access_token');
    // Prefer access_token over legacy user.access_token to avoid sending stale JWTs.
    const accessToken = dsAccessRef || (legacyUserRef && legacyUserRef.access_token);
    const idFlussoLocal = localStorage.getItem('idFlusso');
    const currentLanguage = localStorage.getItem('lang');
    // Ensure headers are set on the specific request (not only on defaults),
    // so that retried requests don't carry a stale Authorization header.
    request.headers = request.headers || {};
    if (accessToken) {
      request.headers.Authorization = `Bearer ${accessToken}`;
    }
    request.headers.requestId = request.headers.requestId || uuID;
    //keep note of any uuid force used on the request first of getting axios interceptor
    if (idFlussoLocal) request.headers.idFlusso = idFlussoLocal;
    if (currentLanguage) request.headers.Language = currentLanguage;

    return request;
  }
);


axiosInstance.interceptors.response.use(async (response) => {
  const isLoginPath = response.config.url === `${process.env.REACT_APP_API_OVERX_URL}/api/v1/sicurezza/login` || response.config.url === `${process.env.REACT_APP_API_OVERX_URL}/api/v1/sicurezza/refresh-token`;
  if (isLoginPath && process.env.REACT_APP_SSO_LOGIN_DESCOPE_ENABLED === 'true') {
    const decoded = jwtDecode(response.data.access_token);
    if (!decoded) {
      console.error("Invalid refresh token", decoded);
      throw new Error("Invalid token");
    }
    myStorage.setItem("access_token", response.data.access_token);
    myStorage.setItem("refresh_token", response.data.refresh_token);
    myStorage.setItem("token_type", response.data.token_type);
    myStorage.setItem("scope", response.data.scope);
    myStorage.setItem("expires_in", String(response.data.expires_in));
    // Keep legacy 'user' in sync because some parts of the app (and external libs)
    // still read the token from localStorage.user.access_token.
    try {
      const userObj = {
        ...decoded,
        access_token: response.data.access_token,
        refresh_token: response.data.refresh_token ?? null,
        token_type: response.data.token_type ?? null,
        scope: response.data.scope ?? null,
        expires_in: response.data.expires_in ?? null,
      };
      myStorage.setItem("user", JSON.stringify(userObj));
    } catch (e) {
      // best effort only
    }
    /* userRoleSubject.next(decoded.c_role); 
    userIdSubject.next(decoded.sub ?? decoded.legacy_sub);
    isUserBrokerSubject.next(decoded.isUserBroker);
    isSubAgencySubject.next(decoded.isSubAgency);
    userLanguageBranchSubject.next(decoded.branch);
    lobSubject.next(decoded.lobList); */
    // No observable user subject available here; values persisted to localStorage above
  } else if (isLoginPath) {
    myStorage.setItem("access_token", response.data.access_token);
    myStorage.setItem("refresh_token", response.data.refresh_token);
    myStorage.setItem("token_type", response.data.token_type);
    myStorage.setItem("scope", response.data.scope);
    myStorage.setItem("expires_in", String(response.data.expires_in));
    // Keep legacy 'user' in sync for non-Descope login flows too.
    try {
      const decoded = jwtDecode(response.data.access_token);
      const userObj = {
        ...decoded,
        access_token: response.data.access_token,
        refresh_token: response.data.refresh_token ?? null,
        token_type: response.data.token_type ?? null,
        scope: response.data.scope ?? null,
        expires_in: response.data.expires_in ?? null,
      };
      myStorage.setItem("user", JSON.stringify(userObj));
    } catch (e) {
      // best effort only
    }
    /*     userRoleSubject.next(decoded.c_role);
        userIdSubject.next(decoded.sub ?? decoded.legacy_sub);
        isUserBrokerSubject.next(decoded.isUserBroker);
        isSubAgencySubject.next(decoded.isSubAgency);
        userLanguageBranchSubject.next(decoded.branch);
        lobSubject.next(decoded.lobList); */
    // No observable user subject available here; values persisted to localStorage above
  }
  return response;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error) {
      const originalRequest = error.config;
      const uuID = crypto.randomUUID();

      if (error.response.status === 401) {
        //retrieve the new token
        try { await AuthService.refreshToken(); } catch (e) { console.log(e) };
        const legacyUserAfterRefresh = JSON.parse(localStorage.getItem('user'));
        const dsAccessAfterRefresh = localStorage.getItem('access_token');
        const accessTokenAfterRefresh = dsAccessAfterRefresh ||  (legacyUserAfterRefresh && legacyUserAfterRefresh.access_token);
        

        if (accessTokenAfterRefresh) {
          // Update defaults for future requests
          axiosInstance.defaults.headers.common = { Authorization: `Bearer ${accessTokenAfterRefresh}`, requestId: uuID };
          // Also update the specific original request headers to avoid using a stale token
          originalRequest.headers = originalRequest.headers || {};
          originalRequest.headers.Authorization = `Bearer ${accessTokenAfterRefresh}`;
          originalRequest.headers.requestId = uuID;
        }

        return axiosInstance(originalRequest);
      }

      // if (error.response.status === 400 || error.response.status === 500) {
      //   throw new Error((error.response && error.response.data) || 'Something went wrong');
      // }
    }

    return Promise.reject((error.response && error.response.data) || 'Something went wrong');
  },
);

const setToken = () => {
  const accessToken = localStorage.getItem('access_token');
  const uuID = crypto.randomUUID();
  if (accessToken) {
    axiosInstance.defaults.headers.common = { Authorization: `Bearer ${accessToken}`, requestId: uuID };
  }
}


axiosInstance.Cattura = (e, taskId, name, fetch, dispatch) => {
  console.log("Err on PutDenuncia ", e);
  const uuID = crypto.randomUUID();  //simuliamo una requestId
  const itemMessageToastError = {
    "requestId": uuID,
    "entityName": name,
    "taskId": taskId,
    "fetchToEval": fetch,
    "localErr": e
  }
  //localErr contiene l'eccez sollevata dal backend API (non worker)
  dispatch(setTotalItemMessageToast(itemMessageToastError));
  const itemError = `{"requestId":"${uuID}", "operation":{"status":"FAILED", "statusCode": "7500"}}`
  const itemErrorObj = { "data": itemError }
  //simuliamo il dispatch della ws
  dispatch(checkTotalItemMessageToast(itemErrorObj));
}

// Estrae il messaggio "parlante" inviato dal backend (ExceptionObject.message).
// Il BFF inoltra il body del microservizio come stringa JSON, quindi gestiamo sia
// stringa (da parsare) sia oggetto già deserializzato. Ritorna null se assente.
axiosInstance.getBackendMessage = (e) => {
  let data = e?.response?.data;
  if (data == null) return null;
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch {
      return data.trim() || null;
    }
  }
  return data?.message || null;
}

export const axiosInstanceService = {
  setToken
}

export default axiosInstance;